import React, { Component } from 'react'
import Responsive from '../../components/Responsive'

export default class BookingPreviusInteractions extends Component {
    state = {
        previus: [
            {
                servicename: 'Office Renting', img: '/images/p1.png', items: [
                    { title: 'Service name', des: 'Office Renting' },
                    { title: 'Date of reservation', des: '18 Aug 2023, 09:30 PM' },
                    { title: 'Booking number', des: '235NS34434VBY43N' },
                    { title: 'Provider', des: 'Sara Mohseni' },
                    { title: 'Recipient', des: 'Pedram Peazhman' },
                    { title: 'Recipient Number', des: '+98 902 1377 118' },
                    { title: 'Reserved date', des: '18 May 2023' },
                    { title: 'Deposit', des: '$100' },
                    { title: 'Settlement amount', des: '$300' },
                    { title: 'Peyment status', des: 'Pending ' },
                ]
            },
            {
                servicename: 'Office Renting', img: '/images/p2.png', items: [
                    { title: 'Service name', des: 'Office Renting' },
                    { title: 'Date of reservation', des: '18 Aug 2023, 09:30 PM' },
                    { title: 'Booking number', des: '235NS34434VBY43N' },
                    { title: 'Provider', des: 'Sara Mohseni' },
                    { title: 'Recipient', des: 'Pedram Peazhman' },
                    { title: 'Recipient Number', des: '+98 902 1377 118' },
                    { title: 'Reserved date', des: '18 May 2023' },
                    { title: 'Deposit', des: '$100' },
                    { title: 'Settlement amount', des: '$300' },
                    { title: 'Peyment status', des: 'Pending ' },
                ]
            },
            {
                servicename: 'Office Renting', img: '/images/p3.png', items: [
                    { title: 'Service name', des: 'Office Renting' },
                    { title: 'Date of reservation', des: '18 Aug 2023, 09:30 PM' },
                    { title: 'Booking number', des: '235NS34434VBY43N' },
                    { title: 'Provider', des: 'Sara Mohseni' },
                    { title: 'Recipient', des: 'Pedram Peazhman' },
                    { title: 'Recipient Number', des: '+98 902 1377 118' },
                    { title: 'Reserved date', des: '18 May 2023' },
                    { title: 'Deposit', des: '$100' },
                    { title: 'Settlement amount', des: '$300' },
                    { title: 'Peyment status', des: 'Pending ' },
                ]
            },
        ]
    }
    render() {
        return (
            <div className='h-100  w-100  scroll-no-scrollbar'>
                {this.state.previus.map((prop, index) => {
                    return (
                        <div className='d-flex m-3 pb-3 bb-gray'>
                            <div>
                                <img className='br-10' width={80} src={prop.img} />
                            </div>
                            <div className='mld-4 w-100'>
                                <div className=' w-100 flexcb'>
                                    <p className='font-size-18 main-c2 weight-600'>{prop.servicename}</p>
                                    <button className='br-20 px-4 py-2' style={{ backgroundColor: '#956DB5' }}>
                                        <p className='white'>More!</p>
                                    </button>
                                </div>
                                <div className='d-flex flex-wrap mt-3'>
                                    {prop.items.map((item, index) => {
                                        return (
                                            <Responsive width={this.props.width} height={'100%'} media={{ xs: '12', 400: '6', 700: '6', lg: '4', xl: '4' }}>
                                                <div className='flexc py-1'>
                                                    <p className='font-size-14 main-c6'>{item.title} :</p>
                                                    <p className='font-size-14 main-c4 mld-2'>{item.des}</p>
                                                </div>
                                            </Responsive>

                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }
}
